import React, { useEffect, useState } from "react";
import Fuse from "fuse.js";
import { useWebSocket } from "../../context/WebSocketContext";
import SubResultadosBarraBusqueda from "./components/SubResultadosBarraBusqueda";

export default function UniversalBarraBusquedaCursos({
  vCursosObtenidas,
  vCategoriesSelected = [],
}) {
  const [vCursoFiltro, setvCursoFiltro] = useState([]);
  const { mensajeWs, enviarMensaje, vIsActivo } = useWebSocket(); // Usa el WebSocket
  const [vIsFocus, setVIsFocus] = useState(false);
  const [vTextSearch, setVTextSearch] = useState("");

  useEffect(() => {
    if (vIsActivo && vIsFocus) {
      console.log("first")
      enviarMensaje({
        metadata: {
          page: 1,
        },
        data: {
          texto: vTextSearch,
          categorias: vCategoriesSelected,
        },
        accion: "BUSCAR_CURSOS",
      });
    }
  }, [vIsActivo, vIsFocus]);

  const mChangeTextSearch = (vText) => {
    enviarMensaje({
      metadata: {
        page: 1,
      },
      data: {
        texto: vText,
        categorias: vCategoriesSelected,
      },
      accion: "BUSCAR_CURSOS",
    });
  };

  useEffect(() => {
    if (mensajeWs !== null && mensajeWs["detail"] !== null) {
      switch (mensajeWs["detail"]["acción"]) {
        case "MOSTRAR_CURSOS":
          console.table(mensajeWs["detail"]["datos"]["cursos"]);
          setvCursoFiltro(mensajeWs["detail"]["datos"]["cursos"]);
          break;

        default:
          console.log("first");
          break;
      }
    }
  }, [mensajeWs]);

  return (
    <div data-figma-id="5381:19949" class="menu-busqueda">
      <div class="box-menu-organizacion-input">
        <img
          src="images/search-3-1.svg"
          data-figma-id="113:9509"
          class="icon-busqueda"
        />
        <input
          type="text"
          placeholder="Buscar curso"
          data-figma-id="5381:19931"
          class="menu-organizacion-texto"
          onChange={(e) => {
            setVTextSearch(e.target.value);
            mChangeTextSearch(e.target.value);
          }}
          onFocus={() => setVIsFocus(true)}
          onBlur={() =>
            setTimeout(() => {
              setVIsFocus(false);
            }, 150)
          }
        />
      </div>
      
      <SubResultadosBarraBusqueda cursos={vCursoFiltro} vIsFocus={vIsFocus} />
      
    </div>
  );
}
